import { Event } from 'src/modules/event/models/event';
import AxiosInstance from 'src/shared/services/axios/interceptor';

const controller = 'WebFormEvent';

export const getNewWebFormEvent = (id: number, custName: string) => {
  const endpoint = `${controller}?id=${id}&custName=${custName}`;
  return AxiosInstance.get<Event>(endpoint);
};
